import { render, staticRenderFns } from "./ThemeColorChooser.vue?vue&type=template&id=6fd7daf2&scoped=true&"
import script from "./ThemeColorChooser.vue?vue&type=script&lang=js&"
export * from "./ThemeColorChooser.vue?vue&type=script&lang=js&"
import style0 from "./ThemeColorChooser.vue?vue&type=style&index=0&id=6fd7daf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7daf2",
  null
  
)

export default component.exports